<div class="cart">
  @for (item of items; track item) {
    <app-cart-item iconColor="dark" [item]="item" [titleModifier]="titleModifier" />
  }

  <div class="cart__divider"></div>

  <app-cart-price [cart]="cart" [page]="page()" />
</div>
